import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const AdminDashboard = () => {
  const { userName } = useContext(AuthContext);

  return (
    <div className="max-w-4xl mx-auto mt-12 px-6 py-8 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-800 mb-4">
        Halo, {userName || 'Admin'} 👋
      </h1>
      <p className="text-gray-600 mb-6">
        Ini adalah <span className="font-medium text-blue-600">Admin Dashboard</span>. Anda memiliki akses untuk mengelola sistem.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-6 border rounded shadow-sm">
          <h2 className="text-xl font-semibold mb-2">📊 Statistik Pengguna</h2>
          <p className="text-gray-500">Fitur ini akan menampilkan statistik jumlah user, login harian, dsb.</p>
        </div>

        <div className="p-6 border rounded shadow-sm">
          <h2 className="text-xl font-semibold mb-2">📚 Manajemen Kursus</h2>
          <p className="text-gray-500">Kelola kursus, modul, dan kuis dari dashboard ini.</p>
        </div>

        <div className="p-6 border rounded shadow-sm">
          <h2 className="text-xl font-semibold mb-2">🔔 Notifikasi</h2>
          <p className="text-gray-500">Kirim broadcast atau pesan khusus ke pengguna.</p>
        </div>

        <div className="p-6 border rounded shadow-sm">
          <h2 className="text-xl font-semibold mb-2">🧩 Fitur Lain</h2>
          <p className="text-gray-500">Akses ke pengaturan sistem, integrasi, dan fitur eksperimen.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
